class HomeBannerSwiper extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('.swiper');
    if (!container || typeof Swiper === 'undefined' || container.swiper) return;

    const speed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;

    const count = this.querySelector('.home-banner__count');
    const updateCount = (swiper) => {
      if (!count) return;
      const total = swiper.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate')).length;
      count.textContent = `${swiper.realIndex + 1}/${total}`;
    };

    this.atmospherePhotos = [...this.querySelectorAll('.home-banner__atmosphere-photo')];
    this.activeAtmosphere = -1;
    this.atmosphereSrc = '';

    const syncSlide = (swiper) => {
      updateCount(swiper);
      this.syncAtmosphere(swiper);
    };

    this.swiper = new Swiper(container, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      speed: 700,
      autoHeight: true,
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: this.querySelector('.home-banner__next'),
        prevEl: this.querySelector('.home-banner__prev'),
      },
      on: {
        init: syncSlide,
        slideChangeTransitionStart: syncSlide,
      },
    });

    requestAnimationFrame(() => this.swiper.update());
  }

  syncAtmosphere(swiper) {
    const img = swiper.slides[swiper.activeIndex]?.querySelector('.home-banner__media img');
    const src = img?.currentSrc || img?.getAttribute('src');
    if (!src || src === this.atmosphereSrc || !this.atmospherePhotos.length) return;

    this.atmosphereSrc = src;
    const nextIndex = this.activeAtmosphere === 0 ? 1 : 0;
    const next = this.atmospherePhotos[nextIndex];

    const reveal = () => {
      if (this.atmosphereSrc !== src) return;
      next.classList.add('is-active');
      if (this.activeAtmosphere >= 0) this.atmospherePhotos[this.activeAtmosphere].classList.remove('is-active');
      this.activeAtmosphere = nextIndex;
    };

    if (next.getAttribute('src') === src && next.complete) {
      reveal();
      return;
    }

    next.onload = () => reveal();
    next.src = src;
  }

  disconnectedCallback() {
    this.swiper?.destroy();
  }
}

customElements.define('home-banner-swiper', HomeBannerSwiper);
